import { get } from "svelte/store";
import { toggleActiveVideo } from "@components/Video";
import { activeVideo, maximized } from "@stores/global";
import { VIDEOS } from "../consts";

/**
 * Post a message to parent window that experience is minimized
 */
export default function minimize() {
  window.parent.postMessage("speakeasy:minimize", "*");
  maximized.update(() => false);

  if (get(activeVideo) === VIDEOS.CONVERSATION) {
    toggleActiveVideo().andPlay();
  }
}
